import React, { useState, useEffect } from 'react';

import ExpenseAttachmentDetailsIndex from './ExpenseAttachmentDetailsIndex';
import ExpenseAttachmentUploadIndex from './ExpenseAttachmentUploadIndex';

export default function UploadExpenseAttachment(props) {
    const [attachment, setAttachment] = useState(null);
    const [fetched, setFetched] = useState(false);

    useEffect(() => {
        fetchAttachment();
    }, []);

    const fetchAttachment = () => {
        setFetched(false);
        let url = props.existsAttachmentUrl;
        if (props.expenseId) {
            let urlObj = new URL(props.existsAttachmentUrl);
            let params = new URLSearchParams(urlObj.search);
            params.append('expense_id', props.expenseId);

            url = urlObj.origin + urlObj.pathname + '?' + params.toString();
        }

        axios
            .get(url)
            .then((res) => {
                setAttachment(res.data.attachment);
            })
            .catch((e) => {
                setAttachment(null);
            })
            .finally(() => {
                setFetched(true);
            });
    };

    return (
        <div>
            {fetched && !attachment && (
                <ExpenseAttachmentUploadIndex
                    getUploadUrl={props.getUploadUrl}
                    existsAttachmentUrl={props.existsAttachmentUrl}
                    expenseId={props.expenseId}
                    linkAttachmentUrl={props.linkAttachmentUrl}
                    acceptedFileTypes={props.acceptedFileTypes}
                    onUploaded={props.onUploaded}
                    fetchAttachment={fetchAttachment}
                />
            )}
            {fetched && !!attachment && <ExpenseAttachmentDetailsIndex attachment={attachment} fetchAttachment={fetchAttachment} />}
        </div>
    );
}
